import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostBinding, Input, Output, ViewChild } from '@angular/core';

/** Shared record section heading; the feature retains expansion state and actions. */
@Component({
  selector:'app-record-section-header',standalone:true,imports:[CommonModule],
  templateUrl:'./record-section-header.component.html',styleUrls:['./record-section-header.component.scss']
})
export class RecordSectionHeaderComponent {
  private static nextId=0;
  @HostBinding('class') readonly hostClass='kt-portlet__head ia-record-section-header';
  @Input() title='';
  @Input() titleId='ia-record-section-'+RecordSectionHeaderComponent.nextId++;
  @Input() controls='';
  @Input() expanded=true;
  @Output() toggled=new EventEmitter<void>();
  @ViewChild('toggle', { static:true }) private toggle:ElementRef<HTMLButtonElement>;

  focusToggle():void { this.toggle?.nativeElement.focus({preventScroll:true}); }
}
